import BaseDialog from "@/components/Modals/BaseDialog";
import { useRouter } from "next/navigation";
import { Button } from "../shadcn/button";
import { Badge } from "../shadcn/badge";
import { useSpotUser } from "@/utils/spotUser";
import { ArrowUpRight } from "lucide-react";
import { Skeleton } from "../shadcn/skeleton";
import { ORG_PERMISSIONS } from "@/constants/permissions";
import { usePermissions } from "@/hooks/usePermissions";

interface IBillingTrialLimitModal {
  isOpen: boolean;
  onClose: () => any;
}

export function BillingTrialLimitModal({
  isOpen,
  onClose,
}: IBillingTrialLimitModal) {
  const router = useRouter();
  const { hasPermission } = usePermissions();

  const planName = "Test plan";
  const title = "Your trial period is over";
  const description =
    "You’ve reached the maximum number of days included in your plan.";
  const buttonText = "Manage plan in Billing";

  return (
    <BaseDialog
      title={title}
      description={
        hasPermission(ORG_PERMISSIONS.ORG.BILLING, "tenant")
          ? description
          : "Please reach out to an administrator to upgrade your plan."
      }
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      size="xl"
    >
      <div className="flex flex-col gap-6">
        <div className="rounded-lg border bg-gray-50 p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-semibold text-muted-foreground">
              Trial period
            </span>
            <Badge variant="outline">{planName}</Badge>
          </div>

          <div className="flex items-end justify-between font-normal text-sm text-primary mb-2">
            <span>30 days</span>
            <span>of 30</span>
          </div>

          <div className="w-full h-2 rounded-full bg-muted">
            <div className="h-2 rounded-full bg-foreground w-full" />
          </div>
        </div>

        {hasPermission(ORG_PERMISSIONS.ORG.BILLING, "tenant") && (
          <Button
            className="flex-1 bg-foreground text-background hover:bg-foreground/90"
            onClick={() => router.push("/settings/administration/billing")}
          >
            <ArrowUpRight size="1rem" />
            {buttonText}
          </Button>
        )}
      </div>
    </BaseDialog>
  );
}
